module.exports = __webpack_public_path__ + "media/images/green-882bce123d1511cc811bfcb94a6aab2c.png";